import { render, staticRenderFns } from "./PengajuanFppk.vue?vue&type=template&id=260e5b35"
import script from "./PengajuanFppk.vue?vue&type=script&lang=js"
export * from "./PengajuanFppk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports